"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.boxFlexFlexWrap = exports.boxFlexBoxDirection = exports.boxFlexAlignItems = exports.boxFlexJustifyContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BoxFlex = function BoxFlex(_ref) {
  var justify = _ref.justify,
      alignItems = _ref.alignItems,
      direction = _ref.direction,
      wrap = _ref.wrap,
      grow = _ref.grow,
      flex = _ref.flex,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    width: grow ? "100%" : null,
    justifyContent: justify,
    flex: flex,
    alignItems: alignItems,
    flexWrap: wrap,
    flexDirection: direction
  }, children);
};

BoxFlex.propTypes = {
  justify: _propTypes.default.oneOf(["flex-start", "center", "flex-end", "space-between", "space-around", "space-evenly"]),
  alignItems: _propTypes.default.oneOf(["flex-start", "center", "flex-end", "stretch", "baseline"]),
  direction: _propTypes.default.oneOf(["row", "row-reverse", "flex-end", "column", "column-reverse"]),
  wrap: _propTypes.default.oneOf(["wrap", "nowrap", "wrap-reverse"]),
  grow: _propTypes.default.bool,
  flex: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node])
};
BoxFlex.defaultProps = {
  justify: "flex-start",
  alignItems: "stretch",
  direction: "row",
  wrap: "wrap",
  grow: false,
  children: null
};
var boxFlexJustifyContent = ["flex-start", "center", "flex-end", "space-between", "space-around", "space-evenly"];
exports.boxFlexJustifyContent = boxFlexJustifyContent;
var boxFlexAlignItems = ["flex-start", "center", "flex-end", "stretch", "baseline"];
exports.boxFlexAlignItems = boxFlexAlignItems;
var boxFlexBoxDirection = ["row", "row-reverse", "flex-end", "column", "column-reverse"];
exports.boxFlexBoxDirection = boxFlexBoxDirection;
var boxFlexFlexWrap = ["wrap", "wrap-reverse", "no-wrap"];
exports.boxFlexFlexWrap = boxFlexFlexWrap;
var _default = BoxFlex;
exports.default = _default;